import './DateRangeSelector.css';

export type DateRange = '7D' | '30D' | '3M' | '6M' | '1Y' | 'All';

export function DateRangeSelector({
  ranges,
  selected,
  onSelect,
}: {
  ranges: DateRange[];
  selected: DateRange;
  onSelect: (range: DateRange) => void;
}) {
  return (
    <div className="date-range-selector" role="group" aria-label="Date range">
      {ranges.map((range) => (
        <button key={range} type="button" data-active={range === selected} onClick={() => onSelect(range)}>
          {range}
        </button>
      ))}
    </div>
  );
}
